import React from "react";
import {
  MessageSquare,
  FileText,
  Ruler,
  Boxes,
  Briefcase,
  TrendingUp,
} from "lucide-react";

const offerings = [
  {
    icon: MessageSquare,
    title: "One-to-One Consultations",
    desc: "Charge for technical discussions.",
  },
  {
    icon: FileText,
    title: "Design Reviews",
    desc: "Review CAD files and engineering designs.",
  },
  {
    icon: Ruler,
    title: "Technical Reports",
    desc: "Provide detailed recommendations.",
  },
  {
    icon: Boxes,
    title: "Project-Based Consulting",
    desc: "Support innovators through prototype development.",
  },
  {
    icon: Briefcase,
    title: "Manufacturing Advisory",
    desc: "Recommend processes, materials and facilities.",
  },
  {
    icon: TrendingUp,
    title: "Long-Term Consulting",
    desc: "Extended engagements with startups and industry.",
  },
];

const FLOW_STEPS = [
  "Profile",
  "Expertise",
  "Services",
  "Pricing",
  "Availability",
  "Get Discovered",
  "Requests",
  "Accept",
  "Consult",
  "Deliver",
  "Payment",
  "Reputation",
];

export default function Earnings() {
  return (
    <section className="w-full bg-[#0a0f1e]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20 lg:py-24">
        {/* Eyebrow */}
        <p className="text-[11px] sm:text-xs tracking-[0.2em] font-semibold text-amber-400 uppercase mb-5">
          Earnings
        </p>

        {/* Headline */}
        <h2 className="font-serif text-white leading-[1.1] text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] max-w-3xl">
          Turn your expertise into an{" "}
          <span className="text-amber-400">income stream.</span>
        </h2>

        {/* Paragraph */}
        <p className="mt-6 sm:mt-7 text-slate-400 text-base sm:text-lg leading-relaxed max-w-2xl">
          Your knowledge and experience can help the next generation of
          innovators build better products. APIC ProtoHub enables verified
          experts to offer professional consultation services and earn
          income.
        </p>

        {/* Cards */}
        <div className="mt-12 sm:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {offerings.map(({ icon: Icon, title, desc }) => (
            <div
              key={title}
              className="rounded-2xl border border-white/10 bg-[#0d1526] p-6 sm:p-7 hover:border-white/20 transition-colors duration-200"
            >
              <div className="w-11 h-11 rounded-xl bg-amber-400/15 flex items-center justify-center mb-6">
                <Icon className="w-5 h-5 text-amber-400" strokeWidth={1.75} />
              </div>
              <h3 className="font-semibold text-white text-lg sm:text-xl mb-2">
                {title}
              </h3>
              <p className="text-slate-400 text-sm sm:text-base leading-relaxed">
                {desc}
              </p>
            </div>
          ))}
        </div>

        {/* Earnings flow */}
        <div className="mt-16 sm:mt-20 text-center">
          <p className="text-[11px] sm:text-xs tracking-[0.2em] font-semibold text-amber-400 uppercase mb-6">
            Earnings Flow
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-3">
            {FLOW_STEPS.map((step, i) => (
              <React.Fragment key={step}>
                <span className="inline-flex items-center rounded-full border border-white/15 bg-white/5 px-4 py-2 text-xs sm:text-sm text-slate-200 whitespace-nowrap">
                  {step}
                </span>
                {i < FLOW_STEPS.length - 1 && (
                  <span className="text-slate-600 text-sm">&rarr;</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}